import { apiClient } from './apiClient';

export interface OverdueByDeptRow {
  /** V1.0.35: ID khoa để click drill-down */
  deptId: string;
  deptCode: string;
  deptName: string;
  total: number;
  overdue: number;
  inProgress: number;
  completed: number;
}

export interface UserPerformanceRow {
  userId: string;
  username: string;
  fullName: string;
  deptName?: string | null;
  total: number;
  completed: number;
  overdue: number;
  onTime: number;
  completionRate: number;
  avgProgress: number;
}

export interface MonthlyProgressRow {
  month: string;
  created: number;
  completed: number;
  overdue: number;
}

export interface PendingSignatureRow {
  requestId: string;
  documentId: string;
  documentName: string;
  creatorName?: string | null;
  totalSigners: number;
  signed: number;
  daysElapsed: number;
  createdAt: string;
}

export const reportsService = {
  async overdueByDept(fromDate?: string, toDate?: string): Promise<OverdueByDeptRow[]> {
    const { data } = await apiClient.get<OverdueByDeptRow[]>('/reports/overdue-by-dept', {
      params: { fromDate, toDate },
    });
    return data;
  },

  async userPerformance(fromDate?: string, toDate?: string, deptId?: string): Promise<UserPerformanceRow[]> {
    const { data } = await apiClient.get<UserPerformanceRow[]>('/reports/user-performance', {
      params: { fromDate, toDate, deptId },
    });
    return data;
  },

  async monthlyProgress(months = 6): Promise<MonthlyProgressRow[]> {
    const { data } = await apiClient.get<MonthlyProgressRow[]>('/reports/monthly-progress', {
      params: { months },
    });
    return data;
  },

  async pendingSignatures(): Promise<PendingSignatureRow[]> {
    const { data } = await apiClient.get<PendingSignatureRow[]>('/reports/pending-signatures');
    return data;
  },

  async exportExcel(reportType: string, params: { fromDate?: string; toDate?: string; deptId?: string } = {}): Promise<void> {
    const response = await apiClient.get(`/reports/${reportType}/export/excel`, {
      params,
      responseType: 'blob',
    });
    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    const now = new Date();
    const timestamp = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}-${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}`;
    a.download = `baocao-${reportType}-${timestamp}.xlsx`;
    a.click();
    URL.revokeObjectURL(url);
  },
};
